// ! AUTO-GENERATED FILE
// ! DO NOT TOUCH !!!

// #pause-sonar#
import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { getAllSupplierIds, GetAllSupplierIds$Params } from '../fn/supplier/get-all-supplier-ids';
import { getSupplier, GetSupplier$Params } from '../fn/supplier/get-supplier';
import { SupplierDto } from '../models/supplier-dto';
import { StrictHttpResponse } from '../strict-http-response';

@Injectable({ providedIn: 'root' })
export class SupplierService extends BaseService {
  /** Path part for operation `getSupplier()` */
  static readonly GetSupplierPath = '/service/v1/supplier/{supplierId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSupplier()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSupplier$Response(params: GetSupplier$Params, context?: HttpContext): Observable<StrictHttpResponse<SupplierDto>> {
    return getSupplier(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSupplier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSupplier(params: GetSupplier$Params, context?: HttpContext): Observable<SupplierDto> {
    return this.getSupplier$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupplierDto>): SupplierDto => r.body),
    );
  }

  /** Path part for operation `getAllSupplierIds()` */
  static readonly GetAllSupplierIdsPath = '/service/v1/supplier/supplierids/{supplierPrefix}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSupplierIds()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSupplierIds$Response(
    params: GetAllSupplierIds$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<string>>> {
    return getAllSupplierIds(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSupplierIds$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSupplierIds(params: GetAllSupplierIds$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getAllSupplierIds$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body),
    );
  }
}

// #continue-sonar#
